var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('filter-condition',{attrs:{"post":_vm.conditionGroupPost},scopedSlots:_vm._u([{key:"condition-content",fn:function(){return [_c('filter-condition-items-list',{attrs:{"post":_vm.providersPost},on:{"check-item":(partOfFilter) => _vm.$emit('set-filter', partOfFilter)}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }